<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="groupId" >
        <span slot="label" >
          <a-tooltip>
            {{$t('客服聊天记录.同会话分组id')}}<template slot="title">{{$t('客服聊天记录.同会话分组id')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.groupId"  :placeholder="$t('通用.输入.请输入')+$t('客服聊天记录.同会话分组id')" />
      </a-form-model-item>
      <a-form-model-item prop="sendUserId" >
        <span slot="label" >
          <a-tooltip>
            {{$t('客服聊天记录.发送者id')}}<template slot="title">{{$t('客服聊天记录.发送者id')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.sendUserId"  :placeholder="$t('通用.输入.请输入')+$t('客服聊天记录.发送者id')" />
      </a-form-model-item>
      <a-form-model-item prop="acceptUserId" >
        <span slot="label" >
          <a-tooltip>
            {{$t('客服聊天记录.发送者id')}}<template slot="title">{{$t('客服聊天记录.发送者id')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.acceptUserId"  :placeholder="$t('通用.输入.请输入')+$t('客服聊天记录.发送者id')" />
      </a-form-model-item>
      <a-form-model-item prop="msg" >
        <span slot="label" >
          <a-tooltip>
            {{$t('客服聊天记录.消息内容')}}<template slot="title">{{$t('客服聊天记录.消息内容')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.msg" :placeholder="$t('通用.输入.请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item prop="msgType" >
        <span slot="label" >
          <a-tooltip>
            {{$t('客服聊天记录.消息类型')}}<template slot="title">{{$t('客服聊天记录.消息类型')}}</template>
          </a-tooltip>
        </span>
      </a-form-model-item>
      <a-form-model-item prop="signType" >
        <span slot="label" >
          <a-tooltip>
            {{$t('客服聊天记录.签收状态')}}<template slot="title">{{$t('客服聊天记录.签收状态')}}</template>
          </a-tooltip>
        </span>
      </a-form-model-item>
      <a-form-model-item prop="readType" >
        <span slot="label" >
          <a-tooltip>
            {{$t('客服聊天记录.是否已读')}}<template slot="title">{{$t('客服聊天记录.是否已读')}}</template>
          </a-tooltip>
        </span>
      </a-form-model-item>
      <a-form-model-item prop="privateType" >
        <span slot="label" >
          <a-tooltip>
            {{$t('客服聊天记录.是否私密')}}<template slot="title">{{$t('客服聊天记录.是否私密')}}</template>
          </a-tooltip>
        </span>
      </a-form-model-item>
      <a-form-model-item prop="businessId" >
        <span slot="label" >
          <a-tooltip>
            {{$t('客服聊天记录.业务id')}}<template slot="title">{{$t('客服聊天记录.业务id')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.businessId"  :placeholder="$t('通用.输入.请输入')+$t('客服聊天记录.业务id')" />
      </a-form-model-item>
      <a-form-model-item prop="remark" >
        <span slot="label" >
          <a-tooltip>
            {{$t('客服聊天记录.备注')}}<template slot="title">{{$t('客服聊天记录.备注')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.remark" :placeholder="$t('通用.输入.请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
        <video style="width: 100%" :src="previewUrl" ref="myVideo"
               :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'" :controls="true"></video>
      </a-modal>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('通用.按钮.保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getNotice, addNotice, updateNotice } from '@/api/customer/notice'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      // 表单参数
      form: {
        id: null,

        groupId: null,

        sendUserId: null,

        acceptUserId: null,

        msg: null,

        msgType: null,

        signType: null,

        readType: null,

        privateType: null,

        businessId: null,

        remark: null,

        createTime: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        msgType: [
          { required: true, message: this.$t('客服聊天记录.消息类型')+this.$t('通用.文本.不能为空'), trigger: 'change' }
        ],
        signType: [
          { required: true, message: this.$t('客服聊天记录.签收状态')+this.$t('通用.文本.不能为空'), trigger: 'change' }
        ],
        readType: [
          { required: true, message: this.$t('客服聊天记录.是否已读')+this.$t('通用.文本.不能为空'), trigger: 'change' }
        ],
        privateType: [
          { required: true, message: this.$t('客服聊天记录.是否私密')+this.$t('通用.文本.不能为空'), trigger: 'change' }
        ],
        businessId: [
          { required: true, message: this.$t('客服聊天记录.业务id')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    previewVideoCancel() {
      this.previewVideoVisible = false;
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        groupId: null,
        sendUserId: null,
        acceptUserId: null,
        msg: null,
        msgType: null,
        signType: null,
        readType: null,
        privateType: null,
        businessId: null,
        remark: null,
        createTime: null,
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getNotice({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updateNotice(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('通用.文本.修改成功')
            addNotice(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
